/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "CitylineChatroomRestApi",
            "endpoint": "https://nt7xwc338e.execute-api.ap-east-1.amazonaws.com/prod",
            "region": "ap-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://gpz4j3q6jjddhn4pmgkpaeu6ue.appsync-api.ap-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-east-1",
    "aws_appsync_authenticationType": "AWS_LAMBDA",
    "aws_content_delivery_bucket": "amplify-citylinechat-hosting-prod",
    "aws_content_delivery_bucket_region": "ap-east-1",
    "aws_content_delivery_url": "https://d16z06qchms2u1.cloudfront.net"
};


export default awsmobile;
